import * as VueRouter from 'vue-router'
import { LoginCallback, navigationGuard } from '@okta/okta-vue'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/implicit/callback',
    name: 'oktaCallback',
    component: LoginCallback,
  },
  {
    path: '/',
    redirect: '/moonpig',
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/greetz',
    redirect: '/moonpig',
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/:brand(moonpig)',
    name: 'brandHome',
    component: Home,
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/:brand/incidents',
    name: 'incidents',
    component: () => import('../views/Incidents.vue'),
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/:brand/incidents/:incident',
    name: 'incident',
    component: () => import('../views/Incident.vue'),
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/:brand/bug',
    name: 'bug',
    component: () => import('../views/Bug.vue'),
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/:brand/comment',
    name: 'comment',
    component: () => import('../views/Comment.vue'),
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
  {
    path: '/:brand/faq',
    name: 'faq',
    component: () => import('../views/FAQ.vue'),
    meta: { requiresAuth: process.env.VUE_APP_USE_AUTH === 'true' },
  },
]

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
})

router.beforeEach(navigationGuard)

export default router
